import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Billing } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useData } from '@hooks/useData';
import { useGetMyAccountAddresses } from '@services/useGetMyAccountAddresses';
import { useGetAllGeoDistricts } from '@services/useGetAllGeoDistricts';
import useCartSummary from '@hooks/useCartSummary';

export function BillingPage() {
    const { t } = useTranslation();
    const { addresses, allGeoDistricts, cart } = useData();
    const { request: requestGetAllGeoDistricts } = useGetAllGeoDistricts();
    const { request: requestGetMyAccountAddresses } = useGetMyAccountAddresses();
    const { formattedCart } = useCartSummary(cart?.data);

    const translations = {
        title: t('billing-component.metatags.title'),
        description: t('billing-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.orderBilling,
        index: false,
    });

    useEffect(() => {
        requestGetMyAccountAddresses();
        requestGetAllGeoDistricts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const formattedAddresses =
        (addresses?.data || [])
            .filter((item) => item.type === 'billing')
            .map((item, key) => {
                const matchingDistrict = Object.values(allGeoDistricts?.data || {}).find(
                    (district) => district.district_code === item.district
                );

                return {
                    value: 'address-' + key,
                    uuid: item.uuid || '',
                    name: item.name || '',
                    lastName: item.lastName || '',
                    fiscalNumber: item.fiscalNumber || '',
                    address: `${item.address || ''} ${item.complement || ''}`.trim(),
                    postalCode: `${item.postalCode || ''} ${matchingDistrict?.name || ''}`.trim(),
                    region: item.region || '',
                    initiallySelected: !!item.primary,
                };
            }) ?? [];

    const formattedTotal = formattedCart();

    return <Billing existingAddresses={formattedAddresses} total={formattedTotal} />;
}
